<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row">
        <div class="col div-button">
          <button
            class="btn btn-success"
            data-toggle="modal"
            data-target="#modalNewBanner"
            @click="reset()"
          >
            Nueva publicación
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <div class="commentary">
            <span
              >Para cambiar el orden de los banner seleccione uno y arrastrelo a
              la posición deseada</span
            >
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-12">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                class="nav-item nav-link active"
                id="nav-home-tab"
                data-toggle="tab"
                href="#nav-home"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
                >Activos</a
              >
              <a
                class="nav-item nav-link"
                id="nav-profile-tab"
                data-toggle="tab"
                href="#nav-profile"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false"
                >Historial</a
              >
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active "
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="card p-3">
                <div class="card-body">
                  <div
                    class="row justify-content-end mb-3"
                    style="text-align: end;"
                  >
                    <div class="col-12 col-md-4 col-lg-3 col-xl-3 mb-2">
                      <button
                        :hidden="hidden.btn"
                        class="btn btn-danger btn-block"
                        @click="clean()"
                      >
                        Limpiar orden
                      </button>
                    </div>

                    <div class="col-12 col-md-4 col-xl-3 col-lg-3">
                      <button
                        :disabled="loading.order"
                        :hidden="hidden.btn"
                        class="btn btn-info btn-block "
                        @click="saveOrders()"
                      >
                        <template v-if="loading.order">
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Cargando...
                        </template>
                        <template v-else>Guardar orden </template>
                      </button>
                    </div>
                  </div>
                  <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width: 4em; height: 4rem;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <caption class="visually-hidden">Listado de Banners</caption>
                        <thead>
                          <tr>
                            <th id="ab-1">Imagen</th>
                            <th id="ab-2">Titulo</th>
                            <th id="ab-3">Tamaño</th>
                            <th id="ab-13">Estado</th>
                          </tr>
                        </thead>
                        <tr v-for="banner in defectList" :key="banner.id">
                          <td style="width: 300px">
                            <img
                              class="img-banner"
                              :src="banner.url"
                              :alt="banner.description"
                            />
                          </td>
                          <td>{{ banner.description }}</td>
                          <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td>
                          <td>
                            <label
                              v-if="banner.status_id == 1"
                              style="color: #dc3545"
                            >
                              {{ banner.status.name }}
                            </label>
                            <label v-else style="color: gray">
                              {{ banner.status.name }}
                            </label>
                          </td>
                        </tr>
                        <draggable v-model="bannerList" tag="tbody">
                          <tr
                            v-for="(banner, index) of bannerList"
                            :key="index"
                          >
                            <td style="width: 300px"
                            >
                              <img
                                class="img-banner"
                                :src="banner.url"
                                :alt="banner.description"
                              />
                            </td>
                            <td v-if="banner.location == 2">{{ banner.name }}</td>
                            <td v-else>{{ banner.description }}</td>
                            <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td>
                            <td>
                              <label
                                v-if="banner.status_id == 1"
                                style="color: #dc3545"
                              >
                                {{ banner.status.name }}
                              </label>
                              <label v-else style="color: gray">
                                {{ banner.status.name }}
                              </label>
                            </td>
                          </tr>
                        </draggable>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div class="card ">
                <div class="card-body">
                  <template v-if="loading.history">
                    <div class="d-flex justify-content-center">
                      <div
                        class="spinner-border text-danger"
                        style="width: 4em; height: 4rem;"
                        role="status"
                      ></div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="table-responsive">
                      <table class="table table-striped table-sm">
                        <caption class="visually-hidden">Listado de Banners</caption>
                        <thead>
                          <tr>
                            <th id="ab-4">Imagen</th>
                            <th id="ab-5">Titulo</th>
                            <th id="ab-15">Tamaño</th>
                            <th id="ab-6">Subtitulo</th>
                            <th id="ab-7">Redirección</th>
                            <th id="ab-8">Estado</th>
                            <th id="ab-9">Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="banner in history" :key="banner.id">
                            <td style="width: 300px"
                            >
                              <img
                                class="img-banner"
                                :src="banner.url"
                                :alt="banner.description"
                              />
                            </td>
                            <td v-if="banner.location == 2">{{ banner.name }}</td>
                            <td v-else>
                              <label v-if="banner.description == null">
                                <small> sin título </small>
                              </label>
                              <label v-else> {{ banner.description }} </label>
                            </td>
                            <td>{{ banner.sizes != null ? banner.sizes.description : ''}}</td>
                            <td>
                              <small v-if="banner.subtitle == null">
                                sin título
                              </small>
                              <label> {{ banner.subtitle }} </label>
                            </td>
                            <td>
                              <small v-if="banner.redirection == null">
                                sin redirección
                              </small>
                              <a target="_blank" :href="banner.redirection">{{ banner.redirection }}</a> 
                            </td>
                            <td>
                              <label
                                v-if="banner.status_id == 1"
                                style="color: #dc3545"
                              >
                                {{ banner.status.name }}
                              </label>
                              <label v-else style="color: gray">
                                {{ banner.status.name }}
                              </label>
                            </td>
                            <td>
                              <div class="btn-group" role="group">
                                <small
                                  v-if="
                                    banner.order == 1 ||
                                      banner.order == 2 ||
                                      banner.order == 3
                                  "
                                  >Banner por defecto / <br />sin
                                  acciones</small
                                >
                                <div v-else class="btn-group" role="group">
                                  <button
                                    class="btn btn-secondary"
                                    title="Editar"
                                    data-toggle="modal"
                                    data-target="#modalUpdateQuestion"
                                    @click="edit(banner)"
                                  >
                                    Editar
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Nueva publicación -->
    <div
      class="modal fade"
      id="modalNewBanner"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-lg">
        <div :class="{ 'is-danger': errorsFile || errorsFile2 }" class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong> Ingrese una nueva publicación</strong> </label
                ><br />
              </div>
              <div class="form-group col-12">
                <div class="row text-black-50">
                  <form class="row mb-3">
                      <label class="col-12">
                        <strong>Origen de la publicación</strong>
                      </label>
                      <br>
                      <div style="display:flex; margin:auto;">
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="form.location = 0" type="radio" name="origin" id="inputRadioBannerOption">
                          <label class="form-check-label" for="inputRadioBannerOption">
                            Banner
                          </label>
                        </div>
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="form.location = 1" type="radio" name="origin" id="inputRadioCampaingOption">
                          <label class="form-check-label" for="inputRadioCampaingOption">
                            Campaña
                          </label>
                        </div>
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="form.location = 2" type="radio" name="origin" id="inputRadioPopupOption">
                          <label class="form-check-label" for="inputRadioPopupOption">
                            Popup Catálogo
                          </label>
                        </div>
                        <div style="padding:0px 50px 0px 50px;" class="form-check">
                          <input class="form-check-input" v-on:change="form.location = 3" type="radio" name="origin" id="inputRadioImgsBackground">
                          <label class="form-check-label" for="inputRadioImgsBackground">
                            Imágenes Background
                          </label>
                        </div>
                      </div>
                  </form>
                </div>
              </div>

              <!-- Creación de banners -->
              <div class="form-group" v-if="form.location == 0">
                <div class="row mb-3 ml-3">
                  <div class="text-black-50" v-for="size in sizes" v-bind:key="size.id">
                    <form ref="form" style="text-align: initial">
                      <label v-bind:for="size.size" style="color: #616161" v-bind:key="size.id">
                        <strong>Subir imagen para {{size.description}}</strong>
                      </label>
                      <br>
                      <input
                        type="file"
                        accept="image/*"
                        v-bind:id="size.size"
                        v-bind:key="size.id"
                        v-bind:name="size.size"
                        class="form-control-file mb-2"
                        style="color: black"
                        @change="onfileSelected($event)"
                        :class="{ 'is-danger': errorsFile || errorsFile2 }"
                      />
                    </form>
                    <div class="commentary">
                      <span>Para {{size.description}} el tamaño de la imagen debe ser {{ size.resolution }} pixeles.</span>
                    </div>
                  </div>
                  <div class="commentary my-2">
                    <span
                      >RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                    </span>
                    <span>El tamaño máximo debe ser de 1MB.</span>
                  </div>
                  <span
                    v-if="errorsFile"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile }}</span
                  >
                  <span
                    v-if="errorsFile2"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2 }}</span
                  >
                </div>
                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Título Banner </strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.title"
                      class="form-control"
                      placeholder="Escribe aquí el título del banner"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación de texto </strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.titleAlign"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Subtítulo Banner </strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.subTitle"
                      class="form-control"
                      placeholder="Escribe aquí el subtítulo del banner"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación de texto </strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.subTitleAlign"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Botón 1 para redirección</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.button_1"
                      class="form-control"
                      placeholder="Escribe aquí el texto del botón 1"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación del botón</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.Alignbutton_1"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong>Redirección del botón 1</strong>
                      </label>
                      <input
                        type="url"
                        v-model="form.redirection_button_1"
                        class="form-control"
                        placeholder="Escribe aquí la url de redirección del botón"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Botón 2 para redirección</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.button_2"
                      class="form-control"
                      placeholder="Escribe aquí el texto del botón 2"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación del botón</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.Alignbutton_2"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                  <div class="row mb-3">
                    <div class="col-12" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong> Redirección del botón 2</strong>
                      </label>
                      <input
                        type="url"
                        v-model="form.redirection_button_2"
                        class="form-control"
                        placeholder="Escribe aquí la url de redirección del botón"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-12" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong> Redirección </strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección"
                    />
                  </div>
                </div>
              </div>

              <!-- Creación de campañas ej: dupla ganadora -->
              <div class="form-group" v-if="form.location == 1">
                <div class="row mb-3">
                  <div class="row mb-3 ml-3">
                    <div class="text-black-50">
                      <form ref="form" style="text-align: initial">
                        <label style="color: #616161">
                          <strong>Subir imagen para la campaña</strong>
                        </label>
                        <br>
                        <input
                          type="file"
                          accept="image/*"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="campaingSelected($event)"
                          :class="{ 'is-danger': errorsFileCamp }"
                        />
                      </form>
                      <div class="commentary">
                        <span v-if="errorsFileCamp" style="font-size:14px !important; padding:5px 0px 5px 0px;" class="text-danger float-left small error-danger">
                          {{ errorsFileCamp }}
                        </span>
                      </div>
                    </div>
                    <div class="commentary my-2">
                      <div class="commentary my-2">
                        <span>Para la campaña el tamaño de la imagen debe ser de 2940 x 9501 pixeles.</span>
                      </div>
                      <div class="commentary my-2">
                        <span>RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).</span>
                      </div>
                      <div class="commentary my-2">
                        <span>El tamaño máximo debe ser de 1MB.</span>
                      </div>
                    </div><br>
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                    ><strong>Título de la campaña </strong>
                    </label>
                    <input
                        type="text"
                        v-model="form.title"
                        class="form-control"
                        placeholder="Escribe aquí el título de la campaña *"
                        :class="{ 'is-danger': errorsTitle }"
                    />
                    <div class="commentary">
                      <span v-if="errorsTitle" style="font-size:14px !important; padding:5px 0px 5px 0px;" class="text-danger float-left small error-danger">
                        {{ errorsTitle }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Creación de popups para usar cuando se desactive el catálogo -->
              <div class="form-group" v-if="form.location == 2">
                <div class="row mb-3">
                  <div class="row mb-3 ml-3">
                    <div class="text-black-50">
                      <form ref="form" style="text-align: initial">
                        <label style="color: #616161">
                          <strong>Subir imagen para el Popup</strong>
                        </label>
                        <br>
                        <input
                          type="file"
                          accept="image/*"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="PopupSelected($event)"
                          :class="{ 'is-danger': errorsFilePopup }"
                        />
                      </form>
                      <div class="commentary">
                        <span v-if="errorsFilePopup" style="font-size:14px !important; padding:5px 0px 5px 0px;" class="text-danger float-left small error-danger">
                          {{ errorsFilePopup }}
                        </span>
                      </div>
                    </div>
                    <div class="commentary my-2">
                      <div class="commentary my-2">
                        <span>Para el popup el tamaño de la imagen debe ser de 375 x 530 pixeles.</span>
                      </div>
                      <div class="commentary my-2">
                        <span>RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).</span>
                      </div>
                      <div class="commentary my-2">
                        <span>El tamaño máximo debe ser de 1MB.</span>
                      </div>
                    </div><br>
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                    ><strong>Título del Popup </strong>
                    </label>
                    <input
                        type="text"
                        v-model="form.titlePopup"
                        class="form-control"
                        placeholder="Escribe aquí el título del Popup*"
                        :class="{ 'is-danger': errorsTitlePopup }"
                    />
                    <div class="commentary">
                      <span v-if="errorsTitlePopup" style="font-size:14px !important; padding:5px 0px 5px 0px;" class="text-danger float-left small error-danger">
                        {{ errorsTitlePopup }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Creación de imágenes para background -->
              <div style="min-width:100%" class="form-group" v-if="form.location == 3">
                <div class="row mb-3">
                  <div class="col-8" style="text-align:initial; margin:auto;">
                    <label for="state" style="color: #616161"
                      ><strong>Tipo de vista</strong>
                    </label>
                    <select
                      class="form-control"
                      v-model="form.type_view"
                    >
                      <option value="null" disabled selected>Seleccione el tipo de vista</option>
                      <!-- <option value="1">Inicio</option>
                      <option value="2">Havoblog</option>
                      <option value="3">¿Qué es el club?</option>
                      <option value="4">¿Cómo registrar códigos?s</option>
                      <option value="5">Contáctanos</option>
                      <option value="6">Preguntas frecuentes</option>
                      <option value="7">Catálogo</option> -->

                      <option value="8">Registro de usuarios moteros</option>
                      <option value="9">Inicio de sesión lubricador</option>
                      <option value="10">Inicio de sesión motero</option>
                    </select>
                  </div>
                </div>

                <div v-if="form.type_view">
                  <div class="row mb-3 ml-3">
                    <div class="text-black-50" v-for="size in sizes" v-bind:key="size.id">
                      <form ref="form" style="text-align: initial">
                        <label v-bind:for="size.size" style="color: #616161" v-bind:key="size.id">
                          <strong>Subir imagen de fondo para {{size.description}}</strong>
                        </label>
                        <br>
                        <input
                          type="file"
                          accept="image/*"
                          v-bind:id="size.size"
                          v-bind:key="size.id"
                          v-bind:name="size.size"
                          class="form-control-file mb-2"
                          style="color: black"
                          @change="onfileSelected($event)"
                          :class="{ 'is-danger': errorsFile }"
                        />
                      </form>
                      <div class="commentary">
                        <span>Para {{size.description}} el tamaño de la imagen debe ser {{ size.resolution }} pixeles.</span>
                      </div>
                    </div>
                    <div class="commentary my-2">
                      <span
                        >RECOMENDACIÓN: solo se permiten imágenes en formato (jpg,jpeg,png).
                      </span>
                      <span>El tamaño máximo debe ser de 1MB.</span>
                    </div>
                    <span v-if="errorsFile" class="text-danger float-left small error-danger">
                      {{ errorsFile }}
                    </span>
                  </div>

                  <div class="row mb-3">
                    <div class="col-8" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong>Título del background (se mostrará en H1)</strong>
                      </label>
                      <input
                        type="text"
                        v-model="form.title_background"
                        class="form-control"
                        placeholder="Escribe aquí el título"
                      />
                      <span v-if="errorsTitle_background" class="text-danger float-left small error-danger">
                        {{ errorsTitle_background }}
                      </span>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-8" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong>Subtítulo del background (se mostrará en H2)</strong>
                      </label>
                      <input
                        type="text"
                        v-model="form.subTitle_background"
                        class="form-control"
                        placeholder="Escribe aquí el subtítulo"
                      />
                      <span v-if="errorsSubTitle_background" class="text-danger float-left small error-danger">
                        {{ errorsSubTitle_background }}
                      </span>
                    </div>
                  </div>

                  <div v-if="form.type_view == 10 || form.type_view == 8" class="row mb-3">
                    <div class="col-5" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong>Texto del botón</strong>
                      </label>
                      <input
                        type="text"
                        v-model="form.button_1"
                        class="form-control"
                        placeholder="Escribe aquí el texto del botón"
                      />
                    </div>
                    <div class="col-6" style="text-align: initial">
                      <label for="state" style="color: #616161;"
                        ><strong>Redirección del botón</strong>
                      </label>
                      <input
                        type="url"
                        v-model="form.redirection_button_1"
                        class="form-control"
                        placeholder="Escribe aquí la url de redirección del botón"
                      />
                    </div>
                  </div>

                </div>
              </div>
              
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div v-if="form.location == 0" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createPublication()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Guardando...
                  </template>
                  <template v-else>Aceptar</template>
                </button>
              </div>
              <div v-if="form.location == 1" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createCampaing()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Guardando...
                  </template>
                  <template v-else>Crear Campaña</template>
                </button>
              </div>
              <div v-if="form.location == 2" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createPopup()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Guardando...
                  </template>
                  <template v-else>Crear Popup</template>
                </button>
              </div>
              <div v-if="form.location == 3" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createBackground()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Guardando...
                  </template>
                  <template v-else>Crear Background</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Editar Banner -->
    <div
      class="modal fade "
      id="modalUpdateQuestion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-question ">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>Editar publicación</strong> </label
                ><br />
              </div>
              <div class="form-group">
                <div v-if="form.location < 2" class="row mb-3 ml-3">
                  <form ref="form" style="text-align: initial">
                    <label for="image" style="color: #616161"
                      ><strong>Subir imagen</strong></label
                    ><br />
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      name="image"
                      class="form-control-file mb-2"
                      style="color: black"
                      @change="onfileSelected($event)"
                      :class="{ 'is-danger': errorsFile || errorsFile2 }"
                    />
                  </form>
                  <div class="commentary">
                    <span
                      >Solo se permiten imagenes en formato (jpg,jpeg,png).
                    </span>
                    <span>Con un tamaño maximo de 1MB</span><br />
                    <span
                      >RECOMENDACIÓN: para dispositivos de escritorio el tamaño
                      de la imagen debe ser 1289 x 640 pixeles.</span
                    >
                  </div>|
                  <span
                    v-if="errorsFile"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile }}</span
                  >
                  <span
                    v-if="errorsFile2"
                    class="text-danger float-left small error-danger"
                    >{{ errorsFile2 }}</span
                  >
                </div>
                <div class="row mb-3" v-if="form.location == 1">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                    ><strong>Título de la campaña</strong>
                    </label>
                    <input
                        type="text"
                        v-model="form.title"
                        class="form-control"
                        placeholder="Escribe aquí el título de la campaña *"
                        readonly
                    />
                  </div>
                  <div class="col-4">
                    <label for="state" style="color: #616161"
                    ><strong>Estado de la campaña:</strong>
                    </label>
                    <select
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.state"
                    >
                      <option value="0" disabled selected>Seleccione</option>
                      <option value="1">Activar</option>
                      <option value="2">Inactivar</option>
                    </select>
                  </div>
                </div>
                <div class="row mb-3" v-if="form.location == 0">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Título Banner</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.title"
                      class="form-control"
                      placeholder="Escribe aquí el título del banner *"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación de texto </strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.titleAlign"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                </div>

                <div class="row mb-3" v-if="form.location == 0">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Subtítulo Banner</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.subTitle"
                      class="form-control"
                      placeholder="Escribe aquí el subtítulo del banner *"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación de texto </strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.subTitleAlign"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                </div>

                <div class="row mb-3" v-if="form.location == 0">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Botón para redirección</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.button_1"
                      class="form-control"
                      placeholder="Escribe aquí el texto del botón"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación del botón</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.Alignbutton_1"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Redirección del botón</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection_button_1"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección del botón"
                    />
                  </div>
                </div>

                <div class="row mb-3" v-if="form.location == 0">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Botón para redirección</strong>
                    </label>
                    <input
                      type="text"
                      v-model="form.button_2"
                      class="form-control"
                      placeholder="Escribe aquí el texto del botón"
                    />
                  </div>
                  <div class="col-4" style="text-align: initial">
                    <label for="state" style="color: #616161"
                      ><strong>Alineación del botón</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.Alignbutton_2"
                    >
                      <option value="null" disabled selected>Seleccione</option>
                      <option value="left">Alinear a la izquierda</option>
                      <option value="center">Centrar</option>
                      <option value="right">Alinear a la derecha</option>
                      <option value="justify">Justificado</option>
                    </select>
                  </div>
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Redirección del botón</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection_button_2"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección del botón"
                    />
                  </div>
                </div>

                <div class="row mb-3" v-if="form.location == 0">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                      ><strong>Redirección</strong>
                    </label>
                    <input
                      type="url"
                      v-model="form.redirection"
                      class="form-control"
                      placeholder="Escribe aquí la url de redirección *"
                    />
                  </div>
                  <div class="col-4">
                    <label for="state" style="color: #616161"
                      ><strong>Estado de publicación:</strong>
                    </label>
                    <select
                      class="form-control"
                      name="state"
                      id="state"
                      v-model="form.state"
                    >
                      <option value="0" disabled selected>Seleccione</option>
                      <option value="1">Activar</option>
                      <option value="2">Inactivar</option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="form.location == 2" class="form-group">
                <div class="row mb-3 ml-3">
                  <form ref="form" style="text-align: initial">
                    <label for="image" style="color: #616161"
                      ><strong>Subir nueva imagen</strong></label
                    ><br />
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      name="image"
                      class="form-control-file mb-2"
                      style="color: black"
                      @change="PopupSelected($event)"
                      :class="{ 'is-danger': errorsFilePopup }"
                    />
                  </form>
                  <div class="commentary">
                    <span
                      >Solo se permiten imagenes en formato (jpg,jpeg,png).
                    </span>
                    <span>Con un tamaño maximo de 1MB</span><br />
                    <span
                      >RECOMENDACIÓN: para dispositivos de escritorio el tamaño
                      de la imagen debe ser 375 x 530 pixeles.</span
                    >
                  </div>
                  <div class="commentary">
                    <span v-if="errorsFilePopup" style="font-size:14px !important; padding:5px 0px 5px 0px;" class="text-danger float-left small error-danger">
                      {{ errorsFilePopup }}
                    </span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-8" style="text-align: initial">
                    <label for="state" style="color: #616161;"
                    ><strong>Título del Popup</strong>
                    </label>
                    <input
                        type="text"
                        v-model="form.titlePopup"
                        class="form-control"
                        placeholder="Escribe aquí el nuevo título del popup*"
                    />
                  </div>
                  <div class="col-4">
                    <label for="state" style="color: #616161">
                      <strong>Estado del popup: </strong>
                      <span style="color:#1da5df;">
                        <strong>{{ form.state == 1 ? 'Activo' : 'Inactivo' }}</strong>
                      </span>
                    </label>
                    <select
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.state"
                    >
                      <option value="0" disabled selected>Seleccione</option>
                      <option value="1">Activar</option>
                      <option value="2">Inactivar</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div v-if="form.location < 2" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="postUpdate()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
              <div v-if="form.location == 2" class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="updatePopup()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Cargando...
                  </template>
                  <template v-else>Actualizar Popup</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import draggable from "vuedraggable";
import axios from 'axios';

export default {
  data() {
    return {
      errorsFile: false,
      errorsFile2: false,
      errorsFileCamp: false,
      errorsFilePopup: false,
      errorsTitle: false,
      errorsTitlePopup: false,
      errorsStatus: false,
      errorsTitle_background: false,
      errorsSubTitle_background: false,
      sizes: [],
      multipleFiles: [],
      banner1: null,
      banner2: null,
      banner3: null,
      form: {
        id: 0,
        urlImg: "",
        title: "",
        titlePopup: "",
        location: null,
        state: 0,
        subTitle: "",
        titleAlign: "left",
        subTitleAlign: "left",
        redirection: "",
        button_1: null,
        Alignbutton_1: "left",
        redirection_button_1: null,
        button_2: null,
        Alignbutton_2: "left",
        redirection_button_2: null,
        title_background: null,
        titleAlign_background: "left",
        subTitle_background: null,
        subTitleAlign_background: "left",
        type_view: null,
      },
      currentForm: {},
      file: null,
      fileCampaing: null,
      filePopup: null,
      type: 6,
      type_background: 8,
      bannerList: [],
      currentList: [],
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        order: false
      },
      hidden: {
        btn: false
      },
      history: [],
      sizeName: null,
      defectList: []
    };
  },
  components: {
    draggable
  },
  methods: {
    saveOrders() {
      var listOrders = [];
      // var cont = 4; // 4 por que hay 3 por defecto
      var cont = 0;
      for (let i = 0; i < this.bannerList.length; i++) {
        listOrders.push({
          id: this.bannerList[i].id,
          order: cont++
        });
      }
      var data = {
        orders: listOrders
      };
      this.loading.order = true;
      axios
        .post("superAdmin/files/banner/setOrders", data)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.getImg();
            this.hidden.btn = true;
          }
          this.loading.order = false;
        })
        .catch(error => {
          this.loading.order = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    findSizeName(sizeId){
      this.sizeName = this.sizes.find(name => name.id === sizeId);
      if (!this.sizeName)
        this.sizeName = "";
      else
        this.sizeName = this.sizeName.description;
    },
    clean() {
      this.bannerList = this.currentList;
    },
    onfileSelected(event) {
      let app = this;
      var fileSize = event.target.files[0].size;
      if (fileSize > 1000000) {
        this.errorsFile = "El archivo no debe superar 1MB";
      } else {
        this.errorsFile = false;
        this.errorsFile2 = false;
        app.file = event.target.files[0];
        // console.log('app.file: ', app.file);
      }
    },
    campaingSelected(e){
      var fileSize = e.target.files[0].size;
      if (fileSize > 2000000) {
        this.errorsFileCamp = "El archivo no debe superar 2MB";
      } else {
        this.errorsFileCamp = false;
        this.fileCampaing = e.target.files[0];
        // console.log('this.fileCampaing: ', this.fileCampaing);
      }
    },
    PopupSelected(e){
      var fileSize = e.target.files[0].size;
      if (fileSize > 1000000) {
        this.errorsFilePopup = "El archivo no debe superar 2MB";
      } else {
        this.errorsFilePopup = false;
        this.errorsFilePopup = false;
        this.filePopup = e.target.files[0];
        // console.log('this.filePopup: ', this.filePopup);
      }
    },
    validform() {
      let app = this;
      if (app.file == null){
        alert('Las imágenes para Desktop, Tablet y Mobile son requeridas');
        app.errorsFile = "Las 3 imágenes son requeridas";
      }
      if (!app.errorsFile && !app.errorsTitle) {
        return true;
      }
      return false;
    },
    validFormCampaing(){
      if (this.fileCampaing == null){
        alert('Las imagen de la campaña es requerida');
        this.errorsFileCamp = "La imagen es requerida";
      }
      if (this.form.title == "" || this.form.title == null) {
        this.errorsTitle = "El título de la campaña es requerido.";
      }
      if (!this.errorsFileCamp && !this.errorsTitle) {
        return true;
      }
      return false;
    },
    validFormPopup(){
      if (this.filePopup == null){
        alert('Las imagen del popup es requerida');
        this.errorsFilePopup = "La imagen es requerida";
      }
      if (this.form.titlePopup == "" || this.form.titlePopup == null) {
        this.errorsTitlePopup = "El título del popup es requerido.";
      }
      if (!this.errorsFilePopup && !this.errorsTitlePopup) {
        return true;
      }
      return false;
    },
    validFormBack(){
      if (this.file == null){
        alert('Las imágenes de fondo son requeridas');
        this.errorsFile = "La imagen es requerida";
      }
      if (this.form.title_background == null) {
        this.errorsTitle_background = "El título es requerido.";
      }
      if (this.form.subTitle_background == null) {
        this.errorsSubTitle_background = "El subtítulo es requerido.";
      }
      if (!this.errorsFile && !this.errorsTitle_background && !this.errorsSubTitle_background) {
        return true;
      }
      return false;
    },
    validformEdit() {
      let app = this;
      if (!app.form.title || !app.form.state) {
        app.errorsTitle = "Al menos un campo es requerido";
      }
      if (!app.errorsFile && !app.errorsTitle && !app.errorsStatus) {
        return true;
      }
      return false;
    },
    async createPublication() {
      if (this.validform()) {
        await this.groupFilesBySize();
        this.saveImg();
      }
    },
    async createCampaing(){
      if(this.validFormCampaing()){
        this.saveCampaing();
      }
    },
    async createPopup(){
      if(this.validFormPopup()){
        this.savePopup();
      }
    },
    async createBackground(){
      if(this.validFormBack()){
        await this.groupFilesBySize();
        this.saveBackground();
      }
    },
    groupFilesBySize(){
      this.sizes.forEach( element => {
        let currentFileWithSize = { file : null, sizeId: "" }
        currentFileWithSize.file = document.getElementById(element.size).files[0];
        currentFileWithSize.sizeId = element.id;
        this.multipleFiles.push(currentFileWithSize);
      });
      this.banner1 = this.multipleFiles[0];
      this.banner2 = this.multipleFiles[1];
      this.banner3 = this.multipleFiles[2];
      // console.log('banner1: ', this.banner1);
      // console.log('banner2: ', this.banner2);
      // console.log('banner3: ', this.banner3);
    },
    // updatePublication() {
    //   if (true) {
    //     this.postUpdate();
    //   }
    // },
    deletePublication() {
      console.log("Eliminado");
    },
    deleteData(banner) {
      let app = this;
      app.form.id = banner.id;
      console.log(app.form.id);
    },
    reset() {
      let app = this;
      app.form.title = "";
      app.form.state = 0;
      app.errorsFile = false;
      app.errorsTitle = false;
      app.errorsStatus = false;
      app.errorsFile2 = false;
      this.$refs.form.reset();
      setTimeout(() => {
        this.errorsTitle = false;
        this.errorsFile = false;
      }, 0);
    },
    edit(banner) {
      this.currentForm.title = banner.description;
      this.currentForm.state = banner.status_id;
      let app = this;
      app.errorsFile = false;
      app.errorsTitle = false;
      app.errorsStatus = false;
      app.errorsFile2 = false;
      app.file = {};
      app.form.id = banner.id;
      app.form.title = banner.description;
      app.form.state = banner.status_id;
      app.form.location = banner.location;
      app.form.subTitle = banner.subtitle;
      app.form.titleAlign = banner.title_align;
      app.form.subTitleAlign = banner.subtitle_align;
      app.form.redirection = banner.redirection;
      // console.log(banner);
      return banner;
    },
    saveCampaing(){
      var fileName = null;
      const formDataCampaing = new FormData();
      // console.log('this.fileCampaing ', this.fileCampaing);
      if(this.fileCampaing != null){
        formDataCampaing.append("file", this.fileCampaing);
        formDataCampaing.append("size", 5);
        if (!fileName)
          fileName = this.fileCampaing.name;
      }
      formDataCampaing.append("name", fileName);
      formDataCampaing.append("type", this.type);
      formDataCampaing.append("description", this.form.title);
      formDataCampaing.append("location", this.form.location);
      this.loading.changeDoc = true;
      axios
        .post("admin/file/uploadFile", formDataCampaing)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            this.getImg();
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    savePopup(){
      const formDataPopup = new FormData();
      // console.log('this.filePopup ', this.filePopup);
      if(this.filePopup != null){
        formDataPopup.append("file", this.filePopup);
        formDataPopup.append("size", 5);
      }
      formDataPopup.append("name", this.form.titlePopup);
      formDataPopup.append("type", this.type);
      formDataPopup.append("location", this.form.location);
      this.loading.changeDoc = true;
      axios
        .post("admin/file/uploadFile", formDataPopup)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            this.getImg();
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    saveImg() {
      var fileName = null;
      const formData = new FormData();
      // console.log('this.banner1 ', this.banner1);
      if(this.banner1 != ""){
        formData.append("file", this.banner1.file);
        formData.append("size", this.banner1.sizeId);
        if (!fileName)
          fileName = this.banner1.file.name;
      }
      formData.append("name", fileName);
      formData.append("type", this.type);
      formData.append("description", this.form.title);
      formData.append("redirection", this.form.redirection);
      formData.append("subTitle", this.form.subTitle);
      formData.append("location", this.form.location);
      formData.append("titleAlign", this.form.titleAlign);
      formData.append("subTitleAlign", this.form.subTitleAlign);
      formData.append("button_1", this.form.button_1);
      formData.append("Alignbutton_1", this.form.Alignbutton_1);
      formData.append("redirection_button_1", this.form.redirection_button_1);
      formData.append("button_2", this.form.button_2);
      formData.append("Alignbutton_2", this.form.Alignbutton_2);
      formData.append("redirection_button_2", this.form.redirection_button_2);
      this.loading.changeDoc = true;
      // superAdmin/files/create
      axios
        .post("admin/file/uploadFile", formData)
        .then(res => {
          if (res.data.cod == 0) {
            var fileName = null;
            const formData1 = new FormData();
            if(this.banner2 != ""){
              formData1.append("file", this.banner2.file);
              formData1.append("size", this.banner2.sizeId);
              if (!fileName)
                fileName = this.banner2.file.name;
            }
            formData1.append("name", fileName);
            formData1.append("type", this.type);
            formData1.append("description", this.form.title);
            formData1.append("redirection", this.form.redirection);
            formData1.append("subTitle", this.form.subTitle);
            formData1.append("location", this.form.location);
            formData1.append("titleAlign", this.form.titleAlign);
            formData1.append("subTitleAlign", this.form.subTitleAlign);
            formData1.append("button_1", this.form.button_1);
            formData1.append("Alignbutton_1", this.form.Alignbutton_1);
            formData1.append("redirection_button_1", this.form.redirection_button_1);
            formData1.append("button_2", this.form.button_2);
            formData1.append("Alignbutton_2", this.form.Alignbutton_2);
            formData1.append("redirection_button_2", this.form.redirection_button_2);
            this.saveImgBanner1(formData1);
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    saveImgBanner1(formData1) {
      axios
        .post("admin/file/uploadFile", formData1)
        .then(res => {
          if (res.data.cod == 0) {
            var fileName = null;
            const formData2 = new FormData();
            if(this.banner3 != ""){
              formData2.append("file", this.banner3.file);
              formData2.append("size", this.banner3.sizeId);
              if (!fileName)
                fileName = this.banner3.file.name;
            }
            formData2.append("name", fileName);
            formData2.append("type", this.type);
            formData2.append("description", this.form.title);
            formData2.append("redirection", this.form.redirection);
            formData2.append("subTitle", this.form.subTitle);
            formData2.append("location", this.form.location);
            formData2.append("titleAlign", this.form.titleAlign);
            formData2.append("subTitleAlign", this.form.subTitleAlign);
            formData2.append("button_1", this.form.button_1);
            formData2.append("Alignbutton_1", this.form.Alignbutton_1);
            formData2.append("redirection_button_1", this.form.redirection_button_1);
            formData2.append("button_2", this.form.button_2);
            formData2.append("Alignbutton_2", this.form.Alignbutton_2);
            formData2.append("redirection_button_2", this.form.redirection_button_2);
            this.saveImgBanner2(formData2);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    saveImgBanner2(formData2) {
      axios
        .post("admin/file/uploadFile", formData2)
        .then(res => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
            this.loading.changeDoc = false;
            $("#modalNewBanner").modal("hide");
            this.getImg();
          }
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    saveBackground(){
      var fileName = null;
      const formData = new FormData();
      // console.log('this.banner1 ', this.banner1);
      if(this.banner1 != ""){
        formData.append("file", this.banner1.file);
        formData.append("size", this.banner1.sizeId);
        if (!fileName)
          fileName = this.banner1.file.name;
      }
      formData.append("name", fileName);
      formData.append("type", this.type_background);
      formData.append("type_view", this.form.type_view);
      formData.append("description", this.form.title_background);
      formData.append("titleAlign", this.form.titleAlign_background);
      formData.append("subTitle", this.form.subTitle_background);
      formData.append("subTitleAlign", this.form.subTitleAlign_background);
      formData.append("button_1", this.form.button_1);
      formData.append("redirection_button_1", this.form.redirection_button_1);
      this.loading.changeDoc = true;
      axios
      .post("admin/file/uploadFile", formData)
      .then(res => {
        if (res.data.cod == 0) {
          var fileName = null;
          const formData1 = new FormData();
          if(this.banner2 != ""){
            formData1.append("file", this.banner2.file);
            formData1.append("size", this.banner2.sizeId);
            if (!fileName)
              fileName = this.banner2.file.name;
          }
          formData1.append("name", fileName);
          formData1.append("type", this.type_background);
          formData1.append("type_view", this.form.type_view);
          formData1.append("description", this.form.title_background);
          formData1.append("titleAlign", this.form.titleAlign_background);
          formData1.append("subTitle", this.form.subTitle_background);
          formData1.append("subTitleAlign_background", this.form.subTitleAlign_background);
          formData1.append("button_1", this.form.button_1);
          formData1.append("redirection_button_1", this.form.redirection_button_1);
          this.saveBackground1(formData1);
        }
      })
      .catch(error => {
        this.loading.changeDoc = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    saveBackground1(formData1) {
      axios
      .post("admin/file/uploadFile", formData1)
      .then(res => {
        if (res.data.cod == 0) {
          var fileName = null;
          const formData2 = new FormData();
          // console.log('this.banner1 ', this.banner1);
          if(this.banner3 != ""){
            formData2.append("file", this.banner3.file);
            formData2.append("size", this.banner3.sizeId);
            if (!fileName)
              fileName = this.banner3.file.name;
          }
          formData2.append("name", fileName);
          formData2.append("type", this.type_background);
          formData2.append("type_view", this.form.type_view);
          formData2.append("description", this.form.title_background);
          formData2.append("titleAlign", this.form.titleAlign_background);
          formData2.append("subTitle", this.form.subTitle_background);
          formData2.append("subTitleAlign_background", this.form.subTitleAlign_background);
          formData2.append("button_1", this.form.button_1);
          formData2.append("redirection_button_1", this.form.redirection_button_1);
          this.saveBackground2(formData2);
        }
      })
      .catch(error => {
        this.loading.changeDoc = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    saveBackground2(formData2) {
      axios
      .post("admin/file/uploadFile", formData2)
      .then(res => {
        if (res.data.cod == 0) {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "success",
            title: "Muy bien",
            text: res.data.message
          });
          this.loading.changeDoc = false;
          $("#modalNewBanner").modal("hide");
          this.getImg();
        }
      })
      .catch(error => {
        this.loading.changeDoc = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    getRequets() {
      axios
        .get("url")
        .then(res => {
          console.log(res.data.data);
          if (res.data.cod == 0) {
            this.data = res.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    postUpdate() {
      // console.log(this.form);
      const formData = new FormData();
      formData.append("id", this.form.id);
      if(this.currentForm.state != this.form.state){
        formData.append("statusId", this.form.state);
      }
      formData.append("description", this.form.title);
      formData.append("redirection", this.form.redirection);
      formData.append("subTitle", this.form.subTitle);
      formData.append("location", this.form.location);
      formData.append("titleAlign", this.form.titleAlign);
      formData.append("subTitleAlign", this.form.subTitleAlign);
      formData.append("button_1", this.form.button_1);
      formData.append("Alignbutton_1", this.form.Alignbutton_1);
      formData.append("redirection_button_1", this.form.redirection_button_1);
      formData.append("button_2", this.form.button_2);
      formData.append("Alignbutton_2", this.form.Alignbutton_2);
      formData.append("redirection_button_2", this.form.redirection_button_2);
      if(this.file.size != undefined){
        formData.append("file", this.file);
        formData.append("name", this.file.name);
      }
      this.loading.changeDoc = true;
      axios
        .post("superAdmin/files/banner/edit", formData)
        .then(res => {
          if (res.data.cod == 0) {
            $("#modalUpdateQuestion").modal("hide");
            this.getImg();
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
          }
          this.loading.changeDoc = false;
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    updatePopup(){
      // console.log(this.form);
      const formData = new FormData();
      formData.append("id", this.form.id);
      if (this.currentForm.state != this.form.state) {
        formData.append("statusId", this.form.state);
      }
      if(this.filePopup != null){
        formData.append("file", this.filePopup);
      }
      formData.append("name", this.form.titlePopup);
      formData.append("location", this.form.location);

      this.loading.changeDoc = true;
      axios
        .post("superAdmin/files/banner/edit", formData)
        .then(res => {
          if (res.data.cod == 0) {
            $("#modalUpdateQuestion").modal("hide");
            this.getImg();
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message
            });
          }
          this.loading.changeDoc = false;
        })
        .catch(error => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    delete() {
      axios
        .delete("url", this.form)
        .then(res => {
          console.log(res.data.data);
          if (res.data.cod == 0) {
            this.$swal(res.data.message, "", "success");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getImg() {
      this.defectList = [];
      this.bannerList = [];
      this.currentList = [];
      this.history = [];
      this.loading.history = true;
      axios
        .get("superAdmin/files/histories/6")
        .then(res => {
          if (res.data.cod == 0) {
            var list = res.data.data;
            for (let i = 0; i < list.length; i++) {
              if (
                list[i].order == 1 ||
                list[i].order == 2 ||
                list[i].order == 3
              ) {
                this.defectList.push(list[i]);
              } else {
                if (list[i].status_id == 1) {
                  this.bannerList.push(list[i]);
                  this.currentList.push(list[i]);
                }
              }
              this.history = res.data.data;
            }
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    getImagesSizes() {
      this.loading.history = true;
      axios
          .get("admin/file/get/imageSize")
          .then(res => {
            this.sizes = res.data.data;
            this.loading.history = false;
          })
          .catch(error => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
    }
  },
  mounted() {
    this.getImg();
    this.getImagesSizes();
  },
  watch: {
    bannerList: function(newL) {
      var cont = 0;
      for (let i = 0; i < this.currentList.length; i++) {
        if (this.currentList[i].id != newL[i].id) {
          cont++;
        }
      }
      if (cont > 0) {
        this.hidden.btn = false;
      } else {
        this.hidden.btn = true;
      }
    },
    "form.title": function (n) {
      if (!n) {
        this.errorsTitle = "El título de la campaña es requerido.";
      } else {
        this.errorsTitle = false;
      }
    },
    "form.titlePopup": function (n) {
      if (!n) {
        this.errorsTitlePopup = "El título de la campaña es requerido.";
      } else {
        this.errorsTitlePopup = false;
      }
    },
    "form.title_background": function (n) {
      if (!n) {
        this.errorsTitle_background = "El título es requerido.";
      } else {
        this.errorsTitle_background = false;
      }
    },
    "form.subTitle_background": function (n) {
      if (!n) {
        this.errorsSubTitle_background = "El subtítulo es requerido.";
      } else {
        this.errorsSubTitle_background = false;
      }
    },
  }
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  /* border-color: #dc3545; */
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>